import { useSelector } from 'react-redux';


export const useIsEventQuestionsLoaded = eventId => useSelector(state => state.events[eventId]?.questions.loaded);
